import { PUBLIC_IMG_PATH } from "../js/util";

const data01 = {
    number: "01",
    title: "STUDIO I'll",
    date: "",
    sub: "OFFICE",
    location: "서울시 서대문구 연희로 57",
    area: "48m² (14.5py)",
    designer: "",
};

const data02 = {
    number: "02",
    title: "시간을담은 집",
    date: "",
    sub: "HOUSE",
    location: "",
    area: "",
    designer: "",
};

const data03 = {
    number: "03",
    title: "OA CAFE",
    date: "",
    sub: "CAFE",
    location: "",
    area: "",
    designer: "",
};

const data04 = {
    number: "04",
    title: "GYESAN TOUWN HOUSE",
    date: "",
    sub: "TOWN HOUSE",
    location: "",
    area: "",
    designer: "",
};

const data05 = {
    number: "05",
    title: "GRAY CITY",
    date: "",
    sub: "SMP, HAIR SLON, OFFICE",
    location: "서울시 송파구 방이동",
    area: "266.74m² (80.6py)",
    designer: "",
};

const data06 = {
    number: "06",
    title: "WHITE HOUSE",
    date: "",
    sub: "HAIR SLON",
    location: "서울시 송파구 방이동",
    area: "133.37m² (40.3py)",
    designer: "",
};

const data07 = {
    number: "07",
    title: "BLUE HOUSE",
    date: "",
    sub: "BEAUTY SLON",
    location: "서울시 송파구 방이동",
    area: "133.37m² (40.3py)",
    designer: "",
};

const data08 = {
    number: "08",
    title: "B CAFE",
    date: "",
    sub: "CAFE",
    location: "",
    area: "",
    designer: "",
};

const data09 = {
    number: "09",
    title: "SONGDO APT",
    date: "",
    sub: "APT",
    location: "인천시 연수구 송도동",
    area: "190m² (58py)",
    designer: "",
};

const data10 = {
    number: "10",
    title: "LIMSOUT (JONGRO OFFICE)",
    date: "",
    sub: "OFFICE",
    location: "서울시 종로구",
    area: "300m² (90.7py)",
    designer: "",
};

const data11 = {
    number: "11",
    title: "BLOW HAIR",
    date: "",
    sub: "HAIR SLON",
    location: "울산시 남구 삼산동",
    area: "218.20m² (66py)",
    designer: "",
};

const data12 = {
    number: "12",
    title: "SHARING OF THOUGHTS #02",
    date: "",
    sub: "EXHIBITION",
    location: "",
    area: "",
    designer: "",
};

const data13 = {
    number: "13",
    title: "KUROZARU",
    date: "",
    sub: "SAKE BAR",
    location: "대전시 유성구 궁동",
    area: "32.7m² (10py)",
    designer: "",
};

const data14 = {
    number: "14",
    title: "TARIMACOI",
    date: "",
    sub: "JEWELRY SHOP",
    location: "서울시 용산구 이촌동",
    area: "",
    designer: "",
};

const data15 = {
    number: "15",
    title: "출항",
    date: "",
    sub: "PUB",
    location: "군포시 산본동",
    area: "72m² (22py)",
    designer: "",
};

const data16 = {
    number: "16",
    title: "MINT CONDITION",
    date: "",
    sub: "HAIR SLON",
    location: "서울시 성동구 성수동",
    area: "165.28m² (50py)",
    designer: "",
};

const data17 = {
    number: "17",
    title: "KEPCO COMMUNITY LOUNGE",
    date: "",
    sub: "LOUNGE",
    location: "세종시 소담동",
    area: "317.35m² (96py)",
    designer: "",
};

const data18 = {
    number: "18",
    title: "YEET HAIR",
    date: "",
    sub: "HAIR SLON",
    location: "서울시 마포구 망원동",
    area: "138.74m² (41py)",
    designer: "",
};

const data19 = {
    number: "19",
    title: "CIGAR BAR",
    date: "",
    sub: "CIGAR SHOP & WINE BAR",
    location: "",
    area: "",
    designer: "",
};

const data20 = {
    number: "20",
    title: "ATOP",
    date: "",
    sub: "PLASTIC SURGERY HOSPITAL",
    location: "인도네시아 자카르타",
    area: "264.46m² (80py)",
    designer: "",
};

const data21 = {
    number: "21",
    title: "PANTIO",
    date: "",
    sub: "PHARMACY",
    location: "서울시 서초구 논현동",
    area: "89.26m² (27py)",
    designer: "",
};

const data22 = {
    number: "22",
    title: "YEET HAIR 2호점",
    date: "",
    sub: "HAIR SLON",
    location: "서울시 마포구 망원동",
    area: "165.29m² (50py)",
    designer: "",
};

const data23 = {
    number: "23",
    title: "잠실 서울 비뇨의학과 의원",
    date: "",
    sub: "urology hospital",
    location: "서울시 송파구 잠실동",
    area: "314.05m² (95py)",
    designer: "",
};


/**
 * @param {string} height
 * @param {string} number
 * @param {string} title
 * @param {string} date
 * @param {string} location
 * @param {string} area
 * @param {string} designer
 * @returns
 */
const projectData = {
    repeat: 3,
    data: [
        // 1
        {
            ...data01,
            style: {
                height: "200px",
                position: "absolute",
                
            },
            mobile_style: {
                height: "200px",
                position: "absolute",
                marginLeft: "4px",
            },
        },
        {
            ...data02,
            style: {
                height: "310px",
                position: "absolute",
                marginLeft: "180px",
            },
            mobile_style: {
                height: "310px", 
                position: "absolute",
                marginLeft: "195px",
            },
        },
        {
            ...data03,
            style: {
                height: "420px",
                position: "absolute",
                marginLeft: "360px",
            },
            mobile_style: {
                height: "440px",
                position: "absolute",
                marginLeft: "24px",
            },
        },
        {
            ...data04,
            style: {
                height: "250px",
                position: "absolute",
                marginLeft: "520px",
            },
            mobile_style: {
                height: "560px",
                position: "absolute",
                marginLeft: "200px",
            },
        },
        {
            ...data05,
            style: {
                height: "490px",
                position: "absolute",
                marginLeft: "620px",
            },
            mobile_style: {
                height: "610px",
                position: "absolute",
                marginLeft: "14px",
            },
        },
        {
            ...data06,
            style: {
                height: "550px",
                position: "absolute",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "760px",
                position: "absolute",
                marginLeft: "12%",
            },
        },
        {
            ...data07,
            style: {
                height: "700px",
                position: "absolute",
                marginLeft: "200px",
            },
            mobile_style: {
                height: "900px",
                position: "absolute",
                marginLeft: "46%",
            },
        },
        {
            ...data08,
            style: {
                height: "830px",
                position: "absolute",
                marginLeft: "405px",
            },
            mobile_style: {
                height: "1000px",
                position: "absolute",
                marginLeft: "calc(20% + 10px)",
            },
        },
        {
            ...data09,
            style: {
                height: "650px",
                position: "absolute",
                marginLeft: "504px",
            },
            mobile_style: {
                height: "1140px",
                position: "absolute",
                marginLeft: "8%",
            },
        },
        {
            ...data10,
            style: {
                height: "880px",
                position: "absolute",
                marginLeft: "50px",
            },
            mobile_style: {
                height: "1260px",
                position: "absolute",
                marginLeft: "50%",
            },
        },
        {
            ...data11,
            style: {
                height: "950px",
                position: "absolute",
                marginLeft: "565px",
            },
            mobile_style: {
                height: "1400px",
                position: "absolute",
                marginLeft: "22%",
            },

        },
        {
            ...data12,
            style: {
                height: "1200px",
                position: "absolute",
                marginLeft: "20px",
            },
            mobile_style: {
                height: "1560px",
                position: "absolute",
                marginLeft: "5%",
            },
        },
        {
            ...data13,
            style: {
                height: "1050px",
                position: "absolute",
                marginLeft: "250px",
            },
            mobile_style: {
                height: "1680px",
                position: "absolute",
                marginLeft: "calc(30% + 54px)",
            },
        },
        {
            ...data14,
            style: {
                height: "1300px",
                position: "absolute",
                marginLeft: "334px",
            },
            mobile_style: {
                height: "1740px",
                position: "absolute",
                marginLeft: "2%",
            },
        },
        {
            ...data15,
            style: {
                height: "1160px",
                position: "absolute",
                marginLeft: "605px",
            },
            mobile_style: {
                height: "1880px",
                position: "absolute",
                marginLeft: "24%",
            },
        },
        {
            ...data16,
            style: {
                height: "1400px",
                position: "absolute",
                marginLeft: "100px",
            },
            mobile_style: {
                height: "2000px",
                position: "absolute",
                marginLeft: "10%",
            },
        },

        {
            ...data17,
            style: {
                height: "1600px",
                position: "absolute",
                marginLeft: "180px",
            },
            mobile_style: {
                height: "2140px",
                position: "absolute",
                marginLeft: "50%",
            },
        },
        {
            ...data18,

            style: {
                height: "1480px",
                position: "absolute",
                marginLeft: "480px",
            },
            mobile_style: {
                height: "2200px",
                position: "absolute",
                marginLeft: "7%",
            },
        },
        {
            ...data19,
            style: {
                height: "1650px",
                position: "absolute",
                marginLeft: "585px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },

          {
            ...data20,
            style: {
                height: "2000px",
                position: "absolute",
                marginLeft: "570px",
            },
            mobile_style: {
                height: "2920px",
                position: "absolute",
                marginLeft: "28px",
            },
        },

         {
            ...data21,
            style: {
                height: "1950px",
                position: "absolute",
                marginLeft: "250px",
            },
            mobile_style: {
                height: "2800px",
                position: "absolute",
                marginLeft: "165px",
            },
        },
        {
            ...data22,
            style: {
                height: "1820px",
                position: "absolute",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "2650px",
                position: "absolute",
                marginLeft: "95px",
            },
        },
        {
            ...data23,
            style: {
                height: "1860px",
                position: "absolute",
                marginLeft: "420px",
            },
            mobile_style: {
                height: "2500 px",
                position: "absolute",
                marginLeft: "10px",
            },
        },

        // 건물 데이터 추가할 때 position : "absolute", 를 꼭 추가할 것 동일한위치에서 건물이 자라는 형식으로 만들어서 붙이지 않으면
        // 두번째 건물부터 옆으로 튀는 현상 발생 모바일도 마찬가지
        // marginLeft : 는 백분율이 아니라 숫자px 값으로 저장할 것 추후 작업시에 건물의 상대값을 보기 편함
        

    /*
        // 2
        {
            ...data01,
            style: {
                height: "1760px",
                marginLeft: "-790px",
            },
            mobile_style: {
                height: "2420px",
                marginLeft: "-80px",
            },
        },
        {
            ...data02,
            style: {
                height: "1820px",
                marginLeft: "60px",
            },
            mobile_style: {
                height: "2580px",
                marginLeft: "-268px",
            },
        },
        {
            ...data03,
            style: {
                height: "1900px",
                marginLeft: "150px",
            },
            mobile_style: {
                height: "2700px",
                position: "absolute",
                marginLeft: "196px",
            },
        },
        {
            ...data04,
            style: {
                height: "2000px",
                marginLeft: "-700px",
            },
            mobile_style: {
                height: "2830px",
                position: "absolute",
                marginLeft: "24%",
            },
        },
        {
            ...data05,
            style: {
                height: "2100px",
                marginLeft: "142px",
            },
            mobile_style: {
                height: "2940px",
                position: "absolute",
                marginLeft: "18px",
            },
        },
        {
            ...data06,
            style: {
                height: "2180px",
                position: "absolute",
                marginLeft: "70px",
            },
            mobile_style: {
                height: "3060px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data07,
            style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "350px",
            },
            mobile_style: {
                height: "3200px",
                position: "absolute",
                marginLeft: "24%",
            },
        },
        {
            ...data08,
            style: {
                height: "2260px",
                position: "absolute",
                marginLeft: "600px",
            },
            mobile_style: {
                height: "3320px",
                position: "absolute",
                marginLeft: "calc(30% + 42px)",
            },
        },
        {
            ...data09,
            style: {
                height: "2460px",
                position: "absolute",
                marginLeft: "120px",
            },
            mobile_style: {
                height: "3440px",
                position: "absolute",
                marginLeft: "14%",
            },
        },
        {
            ...data10,
            style: {
                height: "2520px",
                position: "absolute",
                marginLeft: "438px",
            },
            mobile_style: {
                height: "3600px",
                position: "absolute",
                marginLeft: "51%",
            },
        },
        {
            ...data11,
            style: {
                height: "2650px",
                position: "absolute",
                marginLeft: "60px",
            },
            mobile_style: {
                height: "3660px",
                position: "absolute",
                marginLeft: "09%",
            },
        },
        {
            ...data12,
            style: {
                height: "2740px",
                position: "absolute",
                marginLeft: "364px",
            },
            mobile_style: {
                height: "3800px",
                position: "absolute",
                marginLeft: "-02%",
            },
        },
        {
            ...data13,
            style: {
                height: "2660px",
                position: "absolute",
                marginLeft: "640px",
            },
            mobile_style: {
                height: "3840px",
                position: "absolute",
                marginLeft: "calc(30% + 108px)",
            },
        },
        {
            ...data14,
            style: {
                height: "2900px",
                position: "absolute",
                marginLeft: "120px",
            },
            mobile_style: {
                height: "3960px",
                position: "absolute",
                marginLeft: "11%",
            },
        },
        {
            ...data15,
            style: {
                height: "2940px",
                position: "absolute",
                marginLeft: "515px",
            },
            mobile_style: {
                height: "4070px",
                position: "absolute",
                marginLeft: "45%",
            },
        },
        {
            ...data16,
            style: {
                height: "3100px",
                position: "absolute",
                marginLeft: "30px",
            },
            mobile_style: {
                height: "4180px",
                position: "absolute",
                marginLeft: "02%",
            },
        },
        {
            ...data17,
            style: {
                height: "3180px",
                position: "absolute",
                marginLeft: "280px",
            },
            mobile_style: {
                height: "4320px",
                position: "absolute",
                marginLeft: "51%",
            },
        },
        {
            ...data18,
            style: {
                height: "3060px",
                position: "absolute",
                marginLeft: "634px",
            },
            mobile_style: {
                height: "4440px",
                position: "absolute",
                marginLeft: "20%",
            },
        },
        {
            ...data19,
            style: {
                height: "3300px",
                position: "absolute",
                marginLeft: "540px",
            },
            mobile_style: {
                height: "4580px",
                position: "absolute",
                marginLeft: "08%",
            },
        },
          {
            ...data20,
            style: {
                height: "3180px",
                position: "absolute",
                marginLeft: "580px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },

         {
            ...data21,
            style: {
                height: "3280px",
                position: "absolute",
                marginLeft: "200px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data22,
            style: {
                height: "3000px",
                position: "absolute",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data23,
            style: {
                height: "3080px",
                position: "absolute",
                marginLeft: "400px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },



        // 3
        {
            ...data01,
            style: {
                height: "3360px",
                marginLeft: "-568px",
            },
            mobile_style: {
                height: "4700px",
                marginLeft: "-10px",
            },
        },
        {
            ...data02,
            style: {
                height: "3500px",
                marginLeft: "-80px",
            },
            mobile_style: {
                height: "4830px",
                marginLeft: "-270px",
            },
        },
        {
            ...data03,
            style: {
                height: "3440px",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "4940px",
                position: "absolute",
                marginLeft: "160px",
            },
        },
        {
            ...data04,
            style: {
                height: "3650px",
                marginLeft: "-605px",
            },
            mobile_style: {
                height: "5060px",
                position: "absolute",
                marginLeft: "4%",
            },
        },
        {
            ...data05,
            style: {
                height: "3620px",
                marginLeft: "334px",
            },
            mobile_style: {
                height: "5180px",
                position: "absolute",
                marginLeft: "92px",
            },
        },
        {
            ...data06,
            style: {
                height: "3760px",
                position: "absolute",
                marginLeft: "330px",
            },
            mobile_style: {
                height: "5300px",
                position: "absolute",
                marginLeft: "52%",
            },
        },
        {
            ...data07,
            style: {
                height: "3920px",
                position: "absolute",
                marginLeft: "90px",
            },
            mobile_style: {
                height: "5380px",
                position: "absolute",
                marginLeft: "14%",
            },
        },
        {
            ...data08,
            style: {
                height: "3860px",
                position: "absolute",
                marginLeft: "626px",
            },
            mobile_style: {
                height: "5480px",
                position: "absolute",
                marginLeft: "calc(00% + 30px)",
            },
        },
        {
            ...data09,
            style: {
                height: "4100px",
                position: "absolute",
                marginLeft: "180px",
            },
            mobile_style: {
                height: "5600px",
                position: "absolute",
                marginLeft: "40%",
            },
        },
        {
            ...data10,
            style: {
                height: "4050px",
                position: "absolute",
                marginLeft: "500px",
            },
            mobile_style: {
                height: "5720px",
                position: "absolute",
                marginLeft: "20%",
            },
        },
        {
            ...data11,
            style: {
                height: "4240px",
                position: "absolute",
                marginLeft: "70px",
            },
            mobile_style: {
                height: "5840px",
                position: "absolute",
                marginLeft: "54%",
            },
        },
        {
            ...data12,
            style: {
                height: "4320px",
                position: "absolute",
                marginLeft: "380px",
            },
            mobile_style: {
                height: "5920px",
                position: "absolute",
                marginLeft: "05%",
            },
        },
        {
            ...data13,
            style: {
                height: "4220px",
                position: "absolute",
                marginLeft: "644px",
            },
            mobile_style: {
                height: "6080px",
                position: "absolute",
                marginLeft: "40%",
            },
        },
        {
            ...data14,
            style: {
                height: "4450px",
                position: "absolute",
                marginLeft: "200px",
            },
            mobile_style: {
                height: "6200px",
                position: "absolute",
                marginLeft: "14%",
            },
        },
        {
            ...data15,
            style: {
                height: "4500px",
                position: "absolute",
                marginLeft: "585px",
            },
            mobile_style: {
                height: "6300px",
                position: "absolute",
                marginLeft: "52%",
            },
        },
        {
            ...data16,
            style: {
                height: "4620px",
                position: "absolute",
                marginLeft: "130px",
            },
            mobile_style: {
                height: "6480px",
                position: "absolute",
                marginLeft: "10%",
            },
        },
        {
            ...data17,
            style: {
                height: "4700px",
                position: "absolute",
                marginLeft: "410px",
            },
            mobile_style: {
                height: "6600px",
                position: "absolute",
                marginLeft: "34%",
            },
        },
        {
            ...data18,
            style: {
                height: "4800px",
                position: "absolute",
                marginLeft: "80px",
            },
            mobile_style: {
                height: "6680px",
                position: "absolute",
                marginLeft: "-02%",
            },
        },
        {
            ...data19,
            style: {
                height: "4900px",
                position: "absolute",
                marginLeft: "334px",
            },
            mobile_style: {
                height: "6840px",
                position: "absolute",
                marginLeft: "45%",
            },
        },

          {
            ...data20,
            style: {
                height: "4765px",
                position: "absolute",
                marginLeft: "580px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },

         {
            ...data21,
            style: {
                height: "4700px",
                position: "absolute",
                marginLeft: "200px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data22,
            style: {
                height: "4550px",
                position: "absolute",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data23,
            style: {
                height: "4580px",
                position: "absolute",
                marginLeft: "400px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },


        // 4
        {
            ...data01,
            style: {
                height: "4840px",
                marginLeft: "-138px",
            },
            mobile_style: {
                height: "6920px",
                marginLeft: "-240px",
            },
        },
        {
            ...data02,
            style: {
                height: "5040px",
                marginLeft: "-650px",
            },
            mobile_style: {
                height: "7060px",
                marginLeft: "10px",
            },
        },
        {
            ...data03,
            style: {
                height: "5080px",
                marginLeft: "140px",
            },
            mobile_style: {
                height: "7120px",
                marginLeft: "-374px",
            },
        },
        {
            ...data04,
            style: {
                height: "5240px",
                marginLeft: "-600px",
            },
            mobile_style: {
                height: "7260px",
                marginLeft: "-080px",
            },
        },
        {
            ...data05,
            style: {
                height: "5300px",
                marginLeft: "110px",
            },
            mobile_style: {
                height: "7420px",
                marginLeft: "-90px",
            },
        },
        {
            ...data06,
            style: {
                height: "5400px",
                marginLeft: "-28px",
            },
            mobile_style: {
                height: "7500px",
                marginLeft: "-340px",
            },
        },
        {
            ...data07,
            style: {
                height: "5440px",
                marginLeft: "-728px",
            },
            mobile_style: {
                height: "7640px",
                marginLeft: "06px",
            },
        },
        {
            ...data08,
            style: {
                height: "5550px",
                marginLeft: "70px",
            },
            mobile_style: {
                height: "7710px",
                marginLeft: "-300px",
            },
        },
        {
            ...data09,
            style: {
                height: "5570px",
                marginLeft: "110px",
            },
            mobile_style: {
                height: "7900px",
                marginLeft: "-248px",
            },
        },
        {
            ...data10,
            style: {
                height: "5660px",
                marginLeft: "-816px",
            },
            mobile_style: {
                height: "8000px",
                marginLeft: "08px",
            },
        },
        {
            ...data11,
            style: {
                height: "5810px",
                marginLeft: "-20px",
            },
            mobile_style: {
                height: "8120px",
                marginLeft: "-300px",
            },
        },
        {
            ...data12,
            style: {
                height: "5760px",
                marginLeft: "82px",
            },
            mobile_style: {
                height: "8260px",
                marginLeft: "-260px",
            },
        },
        {
            ...data13,
            style: {
                height: "5940px",
                marginLeft: "-624px",
            },
            mobile_style: {
                height: "8360px",
                marginLeft: "10px",
            },
        },
        {
            ...data14,
            style: {
                height: "6080px",
                
                marginLeft: "60px",
            },
            mobile_style: {
                height: "8460px",
                marginLeft: "-280px",
            },
        },
        {
            ...data15,
            style: {
                height: "5940px",
                marginLeft: "80px",
            },
            mobile_style: {
                height: "8600px",
                marginLeft: "-090px",
            },
        },
        {
            ...data16,
            style: {
                height: "1px",
                marginLeft: "120px",
            },
            mobile_style: {
                height: "8700px",
                position: "absolute",
                marginLeft: "04%",
            },
        },
		{
            ...data17,
            style: {
                height: "6200px",
                marginLeft: "-1000px",
            },
            mobile_style: {
                height: "8700px",
                position: "absolute",
                marginLeft: "04%",
            },
        },
		{
            ...data18,
            style: {
                height: "6280px",
                marginLeft: "30px",
            },
            mobile_style: {
                height: "8700px",
                position: "absolute",
                marginLeft: "04%",
            },
        },
		{
            ...data19,
            style: {
                height: "6180px",
                marginLeft: "30px",
            },
            mobile_style: {
                height: "8700px",
                position: "absolute",
                marginLeft: "04%",
            },
        },

          {
            ...data20,
            style: {
                height: "6460px",
                position: "absolute",
                marginLeft: "580px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },

         {
            ...data21,
            style: {
                height: "6540px",
                position: "absolute",
                marginLeft: "200px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data22,
            style: {
                height: "6420px",
                position: "absolute",
                marginLeft: "40px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        {
            ...data23,
            style: {
                height: "6640px",
                position: "absolute",
                marginLeft: "400px",
            },
            mobile_style: {
                height: "2320px",
                position: "absolute",
                marginLeft: "44%",
            },
        },
        


        // {
        //     ...data18,
        //     style: {
        //         height: "7000px",
        //         position: "absolute",
        //         marginLeft: "500px",
        //     },
        //     mobile_style: {
        //         height: "8940px",
        //         position: "absolute",
        //         marginLeft: "12%",
        //     },
        // },
        // {
        //     ...data19,
        //     style: {
        //         height: "7000px",
        //         position: "absolute",
        //         marginLeft: "620px",
        //     },
        //     mobile_style: {
        //         height: "9100px",
        //         position: "absolute",
        //         marginLeft: "40%",
        //     },
        // },


        // 5
        // {
        //     ...data01,
        //     style: {
        //         height: "450%",
        //         marginLeft: "-80%",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data02,
        //     style: {
        //         height: "480%",
        //         marginLeft: "-30px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data03,
        //     style: {
        //         height: "446%",
        //         marginLeft: "65px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data04,
        //     style: {
        //         height: "475%",
        //         marginLeft: "-50px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data05,
        //     style: {
        //         height: "420%",
        //         marginLeft: "-76%",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data06,
        //     style: {
        //         height: "404%",
        //         marginLeft: "-28px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data07,
        //     style: {
        //         height: "418%",
        //         marginLeft: "-28px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data08,
        //     style: {
        //         height: "430%",
        //         marginLeft: "-30px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },
        // {
        //     ...data09,
        //     style: {
        //         height: "400%",
        //         marginLeft: "-134px",
        //     },
        //     mobile_style: {
        //         height: "100px",
        //         marginLeft: "10px",
        //     },
        // },

        */

    ],
    
};


const HEIGHT_GAP = 1900; // 웹용 간격 건물 사이클 간격조정 중간에 건물이 가려지거나 할때 높이면됨
const HEIGHT_GAP_MOBILE = 2900; // 모바일용 간격
const repeatedData = [];

for (let i = 0; i < projectData.repeat; i++) {
  projectData.data.forEach((item) => {
    const baseHeight = parseFloat(item.style.height); // '200px' -> 200
    const newHeight = baseHeight + i * HEIGHT_GAP;
    const mobileBaseHeight = parseFloat(item.mobile_style.height);
    const newMobileHeight = mobileBaseHeight + i * HEIGHT_GAP_MOBILE;

    repeatedData.push({
      ...item,
      style: {
        ...item.style,
        height: `${newHeight}px`, // 높이만 커짐
        bottom: "0px", // ✅ 바닥 기준
        // top, marginLeft 등은 그대로 유지

        // 3) top, marginTop 등 위에서 배치하는 속성이 있으면 제거해야 함
        top: undefined,
        marginTop: undefined,
      },
      mobile_style: {
        ...item.mobile_style,
        height: `${newMobileHeight}px`,
        // 3) top, marginTop 등 위에서 배치하는 속성이 있으면 제거해야 함
        top: undefined,
        marginTop: undefined,
      },
    });
  });
}

// 반복된 데이터를 projectData에 다시 할당
projectData.data = repeatedData;





const detailImges = {
    0: [
        { src: `${PUBLIC_IMG_PATH}/project0/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project0/016.png` },
    ],
    1: [
        { src: `${PUBLIC_IMG_PATH}/project1/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project1/013.png` },
    ],
    2: [
        { src: `${PUBLIC_IMG_PATH}/project2/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project2/019.png` },
    ],
    3: [
        { src: `${PUBLIC_IMG_PATH}/project3/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project3/009.png` },
    ],
    4: [
        { src: `${PUBLIC_IMG_PATH}/project4/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project4/008.png` },
    ],
    5: [
        { src: `${PUBLIC_IMG_PATH}/project5/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project5/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project5/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project5/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project5/005.png` },
    ],
    6: [
        { src: `${PUBLIC_IMG_PATH}/project6/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project6/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project6/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project6/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project6/005.png` },
    ],
    7: [
        { src: `${PUBLIC_IMG_PATH}/project7/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project7/007.png` },
    ],
    8: [
        { src: `${PUBLIC_IMG_PATH}/project8/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project8/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project8/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project8/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project8/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project8/006.png` },
    ],
    9: [
        { src: `${PUBLIC_IMG_PATH}/project9/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project9/010.png` },
    ],
    10: [
        { src: `${PUBLIC_IMG_PATH}/project10/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/019.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/020.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/021.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/022.png` },
        { src: `${PUBLIC_IMG_PATH}/project10/023.png` },
    ],
    11: [
        { src: `${PUBLIC_IMG_PATH}/project11/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project11/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project11/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project11/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project11/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project11/006.png` },
    ],
    12: [
        { src: `${PUBLIC_IMG_PATH}/project12/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project12/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project12/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project12/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project12/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project12/006.png` },
    ],
    13: [
        { src: `${PUBLIC_IMG_PATH}/project13/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project13/010.png` },
    ],
    14: [
        { src: `${PUBLIC_IMG_PATH}/project14/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project14/014.png` },
    ],
    15: [
        { src: `${PUBLIC_IMG_PATH}/project15/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/019.png` },
        { src: `${PUBLIC_IMG_PATH}/project15/020.png` },
    ],
    16: [
        { src: `${PUBLIC_IMG_PATH}/project16/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project16/016.png` },
    ],
    17: [
        { src: `${PUBLIC_IMG_PATH}/project17/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/019.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/020.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/021.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/022.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/023.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/024.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/025.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/026.png` },
        { src: `${PUBLIC_IMG_PATH}/project17/027.png` },
    ],
    18: [
        { src: `${PUBLIC_IMG_PATH}/project18/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/019.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/020.png` },
        { src: `${PUBLIC_IMG_PATH}/project18/021.png` },
    ],


    19: [
        { src: `${PUBLIC_IMG_PATH}/project19/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project19/019.png` },

    ],

    20: [
        { src: `${PUBLIC_IMG_PATH}/project20/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project20/013.png` },
    ],

    21: [
        { src: `${PUBLIC_IMG_PATH}/project21/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/014.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/015.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/016.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/017.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/018.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/019.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/020.png` },
        { src: `${PUBLIC_IMG_PATH}/project21/021.png` },

    ],

    22: [
        { src: `${PUBLIC_IMG_PATH}/project22/001.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/002.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/003.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/004.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/005.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/006.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/007.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/008.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/009.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/010.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/011.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/012.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/013.png` },
        { src: `${PUBLIC_IMG_PATH}/project22/014.png` },
    ],

};
export { projectData, detailImges };
